module.exports = __webpack_public_path__ + "img/white_paper22.7d1aca91.png";